const state = {
  data: {
    bannerImgUrl:
      "https://www.kuntokruunu.fi/wp-content/uploads/2020/09/lesmills-gtge-long-comp.jpg",
    mautic: {
      tag: "opas",
      segmentID: 7,
      campaignID: 7
    },
    buttons: [
      {
        text: "KuntoKruunun etusivu",
        blank: false,
        link: "https://www.kuntokruunu.fi",
        featured: true,
        iconClass: "bxs-home"
      }
    ],
    shares: {
      facebook:
        "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkuntokruunu.lataaopas.fi",
      messenger:
        "fb-messenger://share/?link=https%3A%2F%2Fkuntokruunu.lataaopas.fi",
      whatsapp:
        "whatsapp://send?text=Hei%21%20%0A%0ALataa%20t%C3%A4st%C3%A4%20opas%20vauhdittamaan%20harjoittelua%3A%20https%3A%2F%2Fkuntokruunu.lataaopas.fi%20%0A%0ATutustu%20my%C3%B6s%20KuntoKruunuun%3A%20https%3A%2F%2Fwww.kuntokruunu.fi",
      email:
        "mailto:?subject=Maksuton%20PDF-opas%20treenaamiseen%21&body=Hei%21%20%0A%0ALataa%20t%C3%A4st%C3%A4%20opas%20vauhdittamaan%20harjoittelua%3A%20https%3A%2F%2Fkuntokruunu.lataaopas.fi%20%0A%0ATutustu%20my%C3%B6s%20KuntoKruunuun%3A%20https%3A%2F%2Fwww.kuntokruunu.fi"
    }
  }
};

const getters = {
  getData: state => state.data
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
